import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../parseError.js';
import { Toast } from '../../../../../../Notification/index.js';

const deleteTourPayTransaction = async ({state, userId, removeTourPayTransaction, updateState, refreshPage}) => {
  const { resource, itemDetails } = state;
  const { tourPayTransactionId, tourStartTime } = itemDetails;
  let parameters = {
    tourPayTransactionId,
    updatingUserId: userId
  };
  const day = moment(tourStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Pay Transaction Deleted', description: `For ${resource.name} on ${day}`};
  try {
    await removeTourPayTransaction(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'removeTourPayTransaction',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Deleting Pay Transaction Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

export default deleteTourPayTransaction;
